import {createContext} from 'react';

export const ColumnVisibilityContext = createContext({});
